import { render, staticRenderFns } from "./RewardTable.vue?vue&type=template&id=5c0319bc"
import script from "./RewardTable.vue?vue&type=script&lang=js"
export * from "./RewardTable.vue?vue&type=script&lang=js"
import style0 from "./RewardTable.vue?vue&type=style&index=0&id=5c0319bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports